module.exports = __webpack_public_path__ + "static/media/0.450c396a.png";